import React from 'react';
import { AnchorContainer, AnchorElement, ArrowCircle } from './Anchor.styles';
import { palette } from 'app_previous/styles/colors';

interface AnchorProps {
  href: string;
  children: React.ReactNode;
  selected?: boolean;
}

const Anchor = ({ href, children, selected }: AnchorProps): JSX.Element => {
  const handleAnchorClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    const element = document.querySelector(href);

    if (!element || typeof document === 'undefined') return;

    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <AnchorContainer>
      {selected && (
        <ArrowCircle>
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8ZM7.53125 11.7812L10.7812 8.53125C11.0625 8.25 11.0625 7.78125 10.7812 7.46875L7.53125 4.25C7.21875 3.9375 6.75 3.9375 6.46875 4.25C6.15625 4.53125 6.15625 5 6.46875 5.3125L9.1875 8.03125L6.46875 10.75C6.15625 11.0312 6.15625 11.5 6.46875 11.7812C6.75 12.0938 7.21875 12.0938 7.53125 11.7812Z'
              fill={palette.accentBlue}
            />
          </svg>
        </ArrowCircle>
      )}
      <AnchorElement
        onClick={handleAnchorClick}
        selected={selected}
      >
        {children}
      </AnchorElement>
    </AnchorContainer>
  );
};

export default Anchor;
